export class CompensacioBicModel {
   public compensatorios: number;
   public diasCompensacionActual: number;
   public diasfaltantesCompensacion: number;
   public diasParametroCompensacion: number;
   public  compensacionBicicletaBasica: CompensacionBicicletaBasicaDTO[];
}


export class CompensacionBicicletaBasicaDTO {
    public idCompesacion: number;
    public totalIngresos: number;
    public estado: string;
    public estadoDominio: string;
    public fechaSolicitudIncentivo: Date;
    public fechaIncentivo: Date;
    public turnoIncentivo: string;
    public aprobadoPor: string;

}
